exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".jumpto input {\n    height: 31px;\n    width: 50px;\n    margin-left: 5px;\n    margin-right: 5px;\n    text-align: center;\n    display: inline-block;\n}", "", {"version":3,"sources":["/Users/huanyu/Code/vueTestDemo/static/bootstrap-table/extensions/page-jump-to/bootstrap-table-page-jump-to.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;CACzB","file":"bootstrap-table-page-jump-to.css","sourcesContent":[".jumpto input {\n    height: 31px;\n    width: 50px;\n    margin-left: 5px;\n    margin-right: 5px;\n    text-align: center;\n    display: inline-block;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./static/bootstrap-table/extensions/page-jump-to/bootstrap-table-page-jump-to.css
// module id = hli5
// module chunks = 58